<template>
  <div class="flex h-screen items-center justify-center">
    <div class="px-4 text-center">
      <h1 class="leadnin-none mb-4 text-9xl font-bold">404</h1>
      <p class="mb-3 text-xl font-semibold">
        Oops, The page you are looking for is not available.
      </p>
      <p class="mx-auto mb-6 w-full max-w-[400px] font-medium">
        We are sorry for the inconvenience, The page you are trying to access
        has been removed or never been existed.
      </p>
      <div>
        <RouterLink
          :to="{ name: 'home' }"
          class="flex items-center justify-center gap-2 text-[14px] font-semibold capitalize leading-none text-primary-100"
        >
          Back to home
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
};
</script>
